export default function SendButton({ disabled = false, onClick, type = "submit" }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className="group px-4 py-4 rounded-xl font-semibold bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-4 focus:ring-purple-500/50 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center"
      style={{ color: 'var(--color-text-on-accent)' }}
    >
      <svg
        className="w-5 h-5 [transform:rotate(90deg)] group-hover:group-enabled:animate-[send-arrow_0.6s_ease-in-out]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
      </svg>
    </button>
  );
}
